import { atom } from 'recoil';

// the index of the currently active channel in the channels object
export const activeChannelAtom = atom({ key: 'activeChannelAtom', default: 0 as number });
